import React from "react";

import { TabControl, TabItem } from "../tabList";

import "./HorizontalScrollTabs.scss";

interface HorizontalScrollTabsProps {
  tabs: TabItem[];
  selected?: string;
  onClick?: (id: string) => any;
}

export const HorizontalScrollTabs = ({
  tabs = [],
  selected,
  onClick,
}: HorizontalScrollTabsProps) => (
  <ul className="horizontal-scroll-tabs">
    {tabs.map((item) => (
      <li key={item.id} className="horizontal-scroll-tabs__tab">
        <TabControl
          item={item}
          selected={selected === item.id}
          onClick={onClick}
        />
      </li>
    ))}
  </ul>
);
